import { DAYS_PATH } from '../../../modules/day'
import { REDUX_LOCAL_KEY } from '../../../modules/redux/constants/local-key'
import { getValueReduxUtil } from '../../../modules/redux/utils/get-value'
import { logUtil } from 'packages/src'
import getByProfileIdDataPeriodDomainListPathsReduxUtil
  from '../../../modules/redux/utils/get-by-profile-id-data-period-domain-list-paths'

export function getDomainListPathDayUtil (instance, state) {
  const dateStr = getValueReduxUtil(instance, REDUX_LOCAL_KEY.DATE)
  logUtil('getDomainListPathDayUtil').debug('dateStr=', dateStr)
  const date = dateStr ? new Date(dateStr) : new Date()
  logUtil('getDomainListPathDayUtil').debug('date=', date)
  return [
    ...getByProfileIdDataPeriodDomainListPathsReduxUtil({
      state,
      instance,
      date
    }),
    DAYS_PATH.ALL
  ]
}
